import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { scanReset } from '../lib/actions/scanActions';
import LanguageSwitcher from './LanguageSwitcher';
import brandLogo from '../assets/kmg_full.png';

function Header() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Le logo ramène toujours à l'accueil : depuis l'accueil on réinitialise juste
  // le scan (retour à la landing) ; depuis une autre page on navigue vers "/".
  const goHome = () => {
    const onHome = window.location.pathname.replace(/\/+$/, '') === '';
    if (onHome) {
      dispatch(scanReset());
    } else {
      window.location.href = '/';
    }
  };

  const path = window.location.pathname.replace(/\/+$/, '');
  const links = [
    { href: '/', match: '', key: 'home' },
    { href: '/games', match: '/games', key: 'games' },
    { href: '/tarifs', match: '/tarifs', key: 'pricing' },
  ];

  return (
    <header className="site-header">
      <button type="button" className="brand" onClick={goHome} aria-label={t('brand')}>
        <img src={brandLogo} alt={t('brand')} className="brand__logo" />
      </button>

      <nav className="site-nav">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            className={`site-nav__link ${path === l.match ? 'is-active' : ''}`}
          >
            {t(`nav.${l.key}`)}
          </a>
        ))}
      </nav>

      <LanguageSwitcher />
    </header>
  );
}

export default Header;
